/**
 * Filtres personnalisés pour le Budget Général
 */
(function() {
  'use strict';

  angular
    .module('observatoireApp')
    // Filtre pour calculer la somme des valeurs d'une propriété d'un tableau d'objets
    .filter('sumByKey', function() {
      return function(items, key) {
        if (!items || !key) {
          return 0;
        }
        return items.reduce(function(total, item) {
          return total + (parseFloat(item[key]) || 0);
        }, 0);
      };
    })
    // Filtre pour formater les nombres avec des séparateurs de milliers
    .filter('formatNumber', function() {
      return function(input) {
        if (input === undefined || input === null) return '';
        
        // Convertir en nombre si c'est une chaîne
        if (typeof input === 'string') {
          input = parseFloat(input);
        }
        
        // Formater avec des séparateurs de milliers
        return input.toLocaleString('fr-FR', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        });
      };
    });
})();
